import { ContentLibraryOpenedFileEntry } from 'features/content-library/types';
import { ContentData } from 'features/layout/features/content/types';
import { OpenedFile } from 'features/room/types';
import {
  ContentProcessingResult,
  createProcessingState,
  trackLatestAndLocked,
} from './contentProcessing';

export type ProcessedFiles = ContentProcessingResult<
  Record<string, ContentLibraryOpenedFileEntry>,
  ContentLibraryOpenedFileEntry
>;

export function processOpenedFilesForRoom(
  openedFiles: OpenedFile[] | null,
  lockedContent: ContentData | null
): ProcessedFiles {
  const files: Record<string, ContentLibraryOpenedFileEntry> = {};
  const state = createProcessingState<ContentLibraryOpenedFileEntry>();

  const lockedId = lockedContent?.type === 'file' ? lockedContent.id : null;

  if (openedFiles) {
    for (const file of openedFiles) {
      const fileData = file.data as ContentLibraryOpenedFileEntry;
      const timestamp = Number(new Date(file.data.date));

      files[file.data.id] = fileData;
      trackLatestAndLocked(fileData, file.data.id, timestamp, lockedId, state);
    }
  }

  return {
    collection: files,
    ...state,
  };
}
